import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      style={{
        padding: '120px 7.6923% 80px',
        textAlign: 'center',
        background: '#FAFAFA'
      }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <p
          style={{
            color: '#E5A93D',
            fontSize: '14px',
            fontWeight: '600',
            letterSpacing: '2px',
            marginBottom: '20px',
            textTransform: 'uppercase'
          }}
        >
          {t('hero.tagline')}
        </p>

        <h1
          className="font-display"
          style={{
            fontSize: '64px',
            fontWeight: '700',
            color: '#0D2C22',
            marginBottom: '24px',
            lineHeight: '1.1'
          }}
        >
          {t('hero.title')}<br />{t('hero.titleLine2')}
        </h1>

        <p
          style={{
            fontSize: '20px',
            color: 'rgba(13, 44, 34, 0.7)',
            marginBottom: '40px',
            lineHeight: '1.6',
            maxWidth: '900px',
            margin: '0 auto 40px'
          }}
        >
          {t('hero.description')}
        </p>

        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginBottom: '40px', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/sales-leads-pro')}
            style={{
              background: '#0D2C22',
              color: '#FFFFFF',
              border: 'none',
              padding: '16px 40px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'all 0.2s',
              boxShadow: '0 2px 8px rgba(13, 44, 34, 0.15)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(13, 44, 34, 0.9)';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#0D2C22';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            {t('hero.ctaExplore')}
          </button>
          <button
            onClick={() => scrollToSection('services')}
            style={{
              background: 'transparent',
              color: '#0D2C22',
              border: '1px solid rgba(13, 44, 34, 0.2)',
              padding: '16px 40px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(13, 44, 34, 0.05)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
            }}
          >
            {t('hero.ctaServices')}
          </button>
        </div>

        <div style={{ display: 'flex', gap: '24px', justifyContent: 'center', color: 'rgba(13, 44, 34, 0.6)', fontSize: '14px', flexWrap: 'wrap', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: '500' }}>
          <span>{t('hero.badge1')}</span>
          <span>•</span>
          <span>{t('hero.badge2')}</span>
          <span>•</span>
          <span>{t('hero.badge3')}</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;